import confetti from 'canvas-confetti';

const CV_COLORS = ['#c4972a', '#a0785a', '#4caf70', '#f5f0e8', '#8b6914'];

export function fireConfetti(intensity: 'light' | 'medium' | 'big' = 'medium') {
  const counts: Record<string, number> = { light: 35, medium: 70, big: 140 };
  const count = counts[intensity];
  confetti({ particleCount: count, angle: 60,  spread: 55, origin: { x: 0 }, colors: CV_COLORS });
  confetti({ particleCount: count, angle: 120, spread: 55, origin: { x: 1 }, colors: CV_COLORS });
}
